import axios from "../../axios";

const api = {
  createProduct({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/supplier-questionnaires/${questionnaireId}/products`, data, headers)
      .then(({ data }) => data);
  },

  updateProduct({ questionnaireId, id, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/supplier-questionnaires/${questionnaireId}/products/${id}`, data, headers)
      .then(({ data }) => data);
  }
};

export default api;